import React from "react";
import { SignatureImageImproved } from "../../components/Reports/utils/SignatureImage";

const ReportSignatureFooter = ({ sign1, sign2, sign3, fontSizeOverride }) => {
  const signs = [sign1, sign2, sign3];
  let style = {};
  fontSizeOverride && (style.fontSize = fontSizeOverride);
  return (
    <div>
      {signs.map((sign) => (
        <div style={{ width: "37.33%", display: "inline-block", ...style }}>
          {sign ? (
            <div style={{ padding: "10px 50px" }}>
              <SignatureImageImproved
                signatureImage={sign.signatureImage}
                underline={true}
                underlineTitle={sign.bottomTitle}
                forceRender={true}
              />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default ReportSignatureFooter;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ReportSignatureFooter.jsx